module.exports = __webpack_public_path__ + "static/media/logo-light.a2dfb89d.svg";